'use strict';

export default class GroupSend {
    constructor() {
        this.name = 'group-send';
        console.log('%s module', this.name.toLowerCase());

        $("#edit-views-send-direct").prop("checked", false);

        $("#edit-views-send-from-name").on('keydown change keyup focusout focusin', function () {
            $("#edit-views-send-from-name").val($("#edit-views-send-from-name").val().replace(/[^0-9a-z ]/gi, ''));
            console.log('Changing')
        })
        $("#edit-views-send-from-mail").on('keydown change keyup focusout focusin', function () {
            var $email = $("#edit-views-send-from-mail").val();
            if ($email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                console.log('valid email')
                $("#edit-views-send-from-mail").removeClass('error-email');
                $('#edit-actions').show();
            } else {
                console.log('invalid email')
                $("#edit-views-send-from-mail").addClass('error-email');
                $('#edit-actions').hide();
            }
            // $("#edit-views-send-from-name").val($("#edit-views-send-from-name").val().replace(/[^0-9a-z ]/gi, ''));
            // console.log('Changing')
        })
    }
}
